import { windowUtils } from '@packages/domain/utils/windowUtils/windowUtils';
import PropTypes from 'prop-types';

const NO_DELAY = 0;
export const RedirectToExternalUrl = ({ url, delay = NO_DELAY }) => {
  setTimeout(() => windowUtils.redirectTo(url), delay);
  return null;
};

RedirectToExternalUrl.propTypes = {
  delay: PropTypes.number,
  url: PropTypes.string.isRequired,
};
